import React from "react";


const ScreenShot = ({summaryImageElement, screenShotReady, image}) => {


  return (
    <div className={"screenshot"} ref={summaryImageElement}>
      {
        screenShotReady ? (
          <img src={image} alt={"ext"}/>
        ) : (
          <div className={"spinner-wrapper"}>
            <div className={"spinner"}/>
          </div>
        )
      }
    </div>
  )
}

export default ScreenShot;
